import classes from "./SelectElement.module.css";
import caretDown from "../../images/CaretDown.svg";
import { useState, useRef, useEffect } from "react";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";

export function SelectElement({
  name,
  value,
  onChange,
  placeholder,
  options = [],
  optionValueKey,
  optionLabelKey,
  disabled,
  width,
  maxHeight,
  maxWidth,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);
  const optionsRef = useRef(null);
  const { t } = useTranslations();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        closeDropdown();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const openDropdown = () => {
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const handleOptionClick = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    closeDropdown();
  };

  const handleTransitionEnd = () => {
    if (!isOpen) setIsVisible(false);
  };

  const selectedLabel = options.find(
    (option) => (optionValueKey ? option[optionValueKey] : option) === value
  );
  const displayLabel = selectedLabel
    ? optionLabelKey
      ? selectedLabel[optionLabelKey]
      : selectedLabel
    : placeholder || "Select...";

  return (
    <div
      className={`${classes.select} ${disabled ? classes.disabled : ""} `}
      ref={wrapperRef}
      style={{ width: width ? width : "" }}
    >
      <div
        className={`${classes.selectHeader} ${isOpen ? classes.open : ""}`}
        onClick={() => !disabled && (isOpen ? closeDropdown() : openDropdown())}
        style={{ maxWidth: maxWidth ? maxWidth : "" }}
      >
        <span title={displayLabel}>{displayLabel}</span>
        <img
          src={caretDown}
          alt=""
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease-out",
          }}
        />
      </div>

      {isVisible && (
        <div
          className={classes.optionsContainer}
          ref={optionsRef}
          onTransitionEnd={handleTransitionEnd}
          style={{
            opacity: isOpen ? 1 : 0,
            maxHeight: maxHeight ? maxHeight : "",
          }}
        >
          {options.length > 0 ? (
            options.map((option, index) => {
              const valueProp = optionValueKey
                ? option[optionValueKey]
                : option;
              const labelProp = optionLabelKey
                ? option[optionLabelKey]
                : option;
              return (
                <div
                  key={index}
                  className={classes.option}
                  onClick={() => handleOptionClick(valueProp)}
                >
                  {labelProp}
                </div>
              );
            })
          ) : (
            <div className={classes.optionDisabled}>
              {t.selectelement.noOptionsFound}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
